import { Box, Button, Typography, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import BenachrichtigungenDropdown from '../../BenachrichtigungenDropdown';

// Desktop-Navigationsleiste (Nav-Buttons + Profil + Logout).
function DesktopNav({ navItems, isLoggedIn, nutzer, onNavClick, onNav, onLogout }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {navItems.map((item, index) => {
                const isLocked = false; // item.premiumRequired && !isPremium;
                return (
                    <Tooltip
                        key={index}
                        title={''}
                        placement="bottom"
                        arrow
                    >
                        <Button
                            onClick={() => onNavClick(item)}
                            color="inherit"
                            startIcon={isLocked
                                ? <LockIcon sx={{ fontSize: '14px !important', opacity: 0.5 }} />
                                : item.icon
                            }
                            sx={{
                                fontWeight: 600,
                                color: isLocked ? 'text.disabled' : 'inherit',
                                textTransform: 'none',
                                '&:hover': {
                                    bgcolor: isLocked
                                        ? 'rgba(59, 130, 246, 0.05)'
                                        : 'rgba(59, 130, 246, 0.1)',
                                },
                            }}
                        >
                            {item.label}
                        </Button>
                    </Tooltip>
                );
            })}

            {isLoggedIn && (
                <>
                    <BenachrichtigungenDropdown />
                    <Box
                        onClick={() => onNav('/profil')}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            ml: 1,
                            px: 2,
                            py: 0.75,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            cursor: "pointer"
                        }}
                    >
                        <PersonIcon sx={{ mr: 1, fontSize: '1.2rem', color: 'primary.main' }} />
                        <Typography variant="body2" fontWeight={600}>
                            {nutzer ? nutzer.vname || nutzer.email : 'Gast'}
                        </Typography>
                    </Box>

                    <Button
                        onClick={onLogout}
                        color="inherit"
                        startIcon={<LogoutIcon />}
                        sx={{
                            fontWeight: 600,
                            color: 'error.main',
                            '&:hover': {
                                bgcolor: 'rgba(239, 68, 68, 0.1)',
                            },
                        }}
                    >
                        Logout
                    </Button>
                </>
            )}
        </Box>
    );
}

export default DesktopNav;
